// Contas das referências (clientes passados a outra agência ou recebidos de outra agência).
// A referência é uma percentagem (normalmente 25%) da parte da comissão que cabe ao lado referenciado
// (angariação ou compra), isto é, metade da comissão total do negócio.
import { r2 } from "./ComRec";

const num = (v) => Number(v || 0);

export const TIPOS_RENDIMENTO = {
  venda: "Venda",
  arrendamento: "Arrendamento",
  referencia_enviada: "Referência enviada",
  referencia_recebida: "Referência recebida",
  financiamento: "Financiamento",
};
export const tipoRendimentoDe = (ref) => (ref.direcao === "enviada" ? "referencia_enviada" : "referencia_recebida");

// Enviada: passámos o cliente a outra agência, que nos paga a referência. O valor da referência é o nosso reporting.
// Recebida: recebemos o cliente de outra agência e pagamo-lhe a referência. O valor sai da nossa parte e não entra no reporting.
export function calcularReferencia({ direcao, comissaoTotal, percentagem, pctConsultor }) {
  const total = num(comissaoTotal);
  const parte = r2(total / 2);
  const valorRef = r2(parte * num(percentagem) / 100);
  const enviada = direcao === "enviada";
  const reporting = enviada ? valorRef : r2(parte - valorRef);
  const consultor = r2(reporting * num(pctConsultor) / 100);
  return { total, parte, valorRef, reporting, consultor, agencia: r2(reporting - consultor), pagaOutraAgencia: enviada ? 0 : valorRef };
}

// Linha de "negócio" sintética para a referência, no formato que a janela de recebimentos já sabe usar.
export function referenciaCR(ref, recs = []) {
  const c = calcularReferencia({ direcao: ref.direcao, comissaoTotal: ref.comissao_total, percentagem: ref.percentagem, pctConsultor: ref.pct_consultor });
  const validas = recs.filter((r) => !r.deleted_at && r.nota_credito_estado !== "emitida" && r.referencia_id === ref.id);
  const rec = r2(validas.reduce((s, r) => s + num(r.valor_cliente), 0));
  const o = {
    k: ref.consultor_id || ref.consultor_nome || "c", externo: false, id: ref.consultor_id || null, nome: ref.consultor_nome || "", fs: [ref.objetivo === "comprar" ? "C" : "A"],
    r: c.reporting, c: c.consultor, recs: validas, rec,
    reportada: r2(validas.filter((r) => r.reportado).reduce((s, r) => s + num(r.valor_cliente), 0)),
    cRec: r2(validas.reduce((s, r) => s + num(r.valor_consultor), 0)),
  };
  o.cMax = o.r > 0 ? r2(o.rec * o.c / o.r) : 0;
  o.pct = num(ref.pct_consultor);
  return { n: ref, comissao: null, total: num(ref.comissao_total), linhas: [o], internas: [o], semConsultor: [], fase: "cpcv", cancelado: ref.estado === "cancelada", arr: false, valor: num(ref.valor_negocio), data: String(ref.created_at || "").slice(0, 10), calculo: c };
}
